import { render, staticRenderFns } from "./addressEdit.vue?vue&type=template&id=09963ced&scoped=true"
import script from "./addressEdit.vue?vue&type=script&lang=js"
export * from "./addressEdit.vue?vue&type=script&lang=js"
import style0 from "./addressEdit.vue?vue&type=style&index=0&id=09963ced&prod&lang=less&scoped=true"
import style1 from "./addressEdit.vue?vue&type=style&index=1&id=09963ced&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09963ced",
  null
  
)

export default component.exports